export const initialValues = {
  reason_option: '',
  report_message: '',
};
